// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  width: 100%;
  height: 100%;
  display: block;
}

ion-grid {
  padding: 1.06rem 2rem 1.56rem 0.375rem;
  display: flex;
  align-items: center;
  background-color: #ffffff;
  margin: 0;
  position: relative;
  border-radius: 0.25rem;
  flex-wrap: wrap;
  height: 100%;
}
ion-grid .info-button {
  position: absolute;
  bottom: 0.3125rem;
  right: 0.3125rem;
  min-width: 0.938rem;
  min-height: 0.938rem;
}
ion-grid form {
  display: flex;
  gap: 0.438rem;
}
ion-grid form .bonus-code-input {
  flex: 1;
}
ion-grid form .bonus-code-input ion-input {
  min-height: 2.625rem;
}
ion-grid form ion-button {
  min-height: 2.75rem;
}
ion-grid .message {
  font-size: 0.75rem;
  font-weight: 400;
  line-height: 1rem;
  text-align: left;
  width: 100%;
  margin-top: 0.1875rem;
}
ion-grid .message.error {
  color: var(--input-error-text);
}
ion-grid .message.success {
  color: var(--input-success-text);
}

ion-item {
  --min-height: unset;
}

@media screen and (max-width: 991px) {
  ion-grid {
    padding: 0.4375rem 2rem 0.5rem 0.375rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/pages/player-dashboard/bonus-section/bonus-section.component.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,YAAA;EACA,cAAA;AACJ;;AACA;EACI,sCAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,SAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,YAAA;AAEJ;AAAI;EACI,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,oBAAA;AAER;AACI;EACI,aAAA;EACA,aAAA;AACR;AACQ;EACI,OAAA;AACZ;AACY;EACI,oBAAA;AAChB;AAEQ;EACI,mBAAA;AAAZ;AAII;EACI,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,WAAA;EACA,qBAAA;AAFR;AAIQ;EACI,8BAAA;AAFZ;AAIQ;EACI,gCAAA;AAFZ;;AAOA;EACI,mBAAA;AAJJ;;AAOA;EACI;IACI,uCAAA;EAJN;AACF","sourcesContent":[":host {\r\n    width: 100%;\r\n    height: 100%;\r\n    display: block;\r\n}\r\nion-grid {\r\n    padding: 1.06rem 2rem 1.56rem 0.375rem;\r\n    display: flex;\r\n    align-items: center;\r\n    background-color: #ffffff;\r\n    margin: 0;\r\n    position: relative;\r\n    border-radius: 0.25rem;\r\n    flex-wrap: wrap;\r\n    height: 100%;\r\n\r\n    .info-button {\r\n        position: absolute;\r\n        bottom: 0.3125rem;\r\n        right: 0.3125rem;\r\n        min-width: 0.938rem;\r\n        min-height:  0.938rem;\r\n    }\r\n\r\n    form {\r\n        display: flex;\r\n        gap: 0.438rem;\r\n\r\n        .bonus-code-input {\r\n            flex: 1;\r\n\r\n            ion-input {\r\n                min-height: 2.625rem;\r\n            }\r\n        }\r\n        ion-button {\r\n            min-height: 2.75rem;\r\n        }\r\n    }\r\n\r\n    .message {\r\n        font-size: 0.75rem;\r\n        font-weight: 400;\r\n        line-height: 1rem;\r\n        text-align: left;\r\n        width: 100%;\r\n        margin-top: 0.1875rem;\r\n\r\n        &.error {\r\n            color: var(--input-error-text);\r\n        }\r\n        &.success {\r\n            color: var(--input-success-text);\r\n        }\r\n    }\r\n}\r\n\r\nion-item {\r\n    --min-height: unset;\r\n}\r\n\r\n@media screen and (max-width: 991px) {\r\n    ion-grid {\r\n        padding: 0.4375rem 2rem 0.5rem 0.375rem;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
